import React from "react"
import { Box, Flex } from "@rebass/grid/emotion"
import styled from "@emotion/styled"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"

import BulletIcon from "../../../../../assets/icons/nova/bullet-orange.svg"

const GwpModalContentWrapper = styled.div`
  svg {
    width: 4px;
    height: 4px;
  }
`

const GwpModalContentMulti = ({ data }) => {
  const { offers, terms } = data
  return (
    <GwpModalContentWrapper>
      <Flex
        flexDirection={["column", null, "row"]}
        className="gap-4 sm:gap-6"
        alignItems={[null, null, "stretch"]}
      >
        {offers.map((offer, i) => {
          const isSingleOffer = offers.length === 1
          return (
            <Box className="flex flex-1 w-full sm:w-[50%]" key={i}>
              <div className="flex flex-col w-full">
                <TextElementNova
                  element="h3"
                  text={offer.heading}
                  className={`${
                    isSingleOffer ? "Body-30-Dia-Strong" : "Body-20-Dia-Strong"
                  } p-1 text-center bg-nova-brand-primary-100 text-nova-base-white rounded-t-[4px]`}
                />
                <div className="flex flex-col flex-1 border border-nova-transparency-black-20 rounded-b-[4px] border-t-0">
                  <div
                    className={`flex ${
                      isSingleOffer
                        ? ""
                        : "max-w-[500px] mx-auto sm:flex-col sm:items-center"
                    } flex-1`}
                  >
                    <div
                      className={`${
                        isSingleOffer
                          ? "w-[150px] md:w-[193px] lg:w-[251px]"
                          : "w-[150px] md:w-[175px] lg:w-[225px]"
                      }`}
                    >
                      <img src={offer.image} alt={offer.heading} />
                    </div>
                    <div
                      className={`flex flex-1 flex-col py-4 pr-4 justify-center ${
                        isSingleOffer ? "" : "md:justify-start sm:pl-4"
                      }`}
                    >
                      <TextElementNova
                        element="p"
                        text={offer.copy}
                        className="Body-10-Dia-Normal pb-2"
                      />
                      <div className="flex flex-col gap-1">
                        {offer.bullets.map((bullet, i) => (
                          <Flex
                            key={`benefit-${i}`}
                            alignItems={"center"}
                            className="gap-2"
                          >
                            <BulletIcon />
                            <TextElementNova
                              text={bullet}
                              className="Body-10-Dia-Normal"
                            />
                          </Flex>
                        ))}
                      </div>
                    </div>
                  </div>
                  <TextElementNova
                    element="p"
                    text={`<i>${offer.value}</i>`}
                    className="Body-10-Dia-Normal text-center text-nova-transparency-black-60 py-2"
                  />
                </div>
              </div>
            </Box>
          )
        })}
      </Flex>

      <TextElementNova
        element="p"
        text={terms}
        className="Caption-10-Dia-Normal text-nova-transparency-black-60 pt-4 sm:pt-10 text-center"
      />
    </GwpModalContentWrapper>
  )
}

export default GwpModalContentMulti
